!<!--  -->
<template>
  <div class="">
    <div
      style="
        padding: 30px;
      "
    >
      <!-- 搜索栏 -->
      <div
        style="
          display: flex;
          align-items: center;
          width: 100%;
          margin-bottom: 20px;
        "
      >
        <div
          style="
            width: 400px;
            display: flex;
            align-items: center;
            margin-right: 15px;
          "
        >
          <span style="width: 180px"> {{$t('i18n_destination_country')}} </span>
          <el-input
            clearable
            @clear="clearQuery('country')"
            :placeholder="addPls('i18n_destination_country', 'input')"
            v-model="queryObj.country"
          >
          </el-input>
        </div>

        <div
          style="
            width: 400px;
            display: flex;
            align-items: center;
            margin-right: 15px;
          "
        >
          <span style="width: 180px"> {{$t('i18n_product_name_cn')}} </span>
          <el-input
            clearable
            @clear="clearQuery('namec')"
            :placeholder="addPls('i18n_product_name_cn', 'input')"
            v-model="queryObj.namec"
          >
          </el-input>
        </div>
        <div style="width: 400px; display: flex; align-items: center">
          <span style="width: 180px"> {{$t('i18n_product_name_en')}} </span>
          <el-input
            clearable
            @clear="clearQuery('namee')"
            :placeholder="addPls('i18n_product_name_en', 'input')"
            v-model="queryObj.namee"
          >
          </el-input>
        </div>
      </div>
      <div style="margin-bottom: 10px">
        <el-button @click="getList(1)" type="primary">{{$t('i18n_Inquiry')}}</el-button>
        <el-button @click="getList(2)" type="primary">{{$t('i18n_refresh')}}</el-button>
        <el-button @click="dialogVisible = true" type="primary"
          >{{$t('i18n_batch_query')}}</el-button
        >
      </div>
      <!-- 表格 -->
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column align="center" type="index" :label="$t('i18n_Serial_number')" width="70">
        </el-table-column>
        <el-table-column
          align="center"
          prop="namec"
          :label="$t('i18n_product_name_cn')"
          min-width="10%"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="namee"
          :label="$t('i18n_product_name_en')"
          min-width="10%"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="goodsType"
          :label="$t('i18n_product_type')"
          min-width="10%"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="country"
          :label="$t('i18n_destination_country')"
          min-width="10%"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="busType"
          :label="$t('i18n_Business_Type')"
          min-width="10%"
        >
        </el-table-column>
        <!-- <el-table-column
          align="center"
          prop="inputer"
          label="录入人"
          min-width="10%"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="inputtime"
          label="录入时间"
          min-width="10%"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="updater"
          label="修改人"
          min-width="10%"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="updatetime"
          label="修改时间"
          min-width="10%"
        >
        </el-table-column> -->
      </el-table>
      <el-pagination
        style="margin-top: 20px; float: right"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryObj.curPage"
        :page-sizes="[5, 20, 50, 100]"
        :page-size="queryObj.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
      <div style="clear: both"></div>
      <!-- 批量查询弹窗 -->
      <!-- Excel上传 -->
      <el-dialog
        :title="$t('i18n_File_Upload')"
        :visible.sync="dialogVisible"
        width="40%"
        center
      >
        <el-upload
          style="text-align: center"
          :show-file-list="false"
          :on-error="handleError"
          :on-success="handleSuccess"
          :before-upload="handleBeforeUpload"
          class="upload-demo"
          drag
          :http-request="uploadSectionFile"
          action=""
          multiple
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">{{$t('i18n_Drag_file_here_or')}}<em>{{$t('i18n_click_Upload')}}</em></div>
          <div class="el-upload__tip" slot="tip">{{$t('i18n_xls_files_only')}}</div>
        </el-upload>
        <span slot="footer" class="dialog-footer">
          <el-button
            style="margin-right: 20px"
            size="mini"
            @click="dialogVisible = false"
            >{{$t('i18n_cancel')}}</el-button
          >
          <el-link target="_blank">
            <el-button size="mini" @click="donwLoadTemplate()" type="primary"
              >{{$t('i18n_Download_Template')}}</el-button
            >
          </el-link>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {addPls} from '@/utils/placeholderI18n'
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      upHeaders: {
        token: "2",
      },

      tableData: [],
      dialogVisible: false,
      queryObj: {
        country: "",
        curPage: 1,
        goodsType: "",
        namec: "",
        namee: "",
        pageSize: 5,
        startIndex: 0,
      },
      total: 0,
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    // 自定义上传
    uploadSectionFile(params) {
      // console.log(params);
      let form = new FormData();
      form.append("file", params.file);
      this.axios
        .post(`/busFbx/getGoodsCategory`, form, { responseType: "arraybuffer" })
        .then((res) => {
          let a = document.createElement("a");
          let blob = new Blob([res.data]);
          let objectUrl = URL.createObjectURL(blob);
          a.setAttribute("href", objectUrl);
          a.setAttribute("download", "分类模板.xls");
          a.click();
          // console.log(objectUrl);
          URL.revokeObjectURL(objectUrl); // 释放内存
        })
        .catch((res) => {
          console.log(res);
        });
    },
    donwLoadTemplate() {
      this.axios
        .get(`/busFbx/getFBXGoodsCategoryTemplate`, {
          responseType: "arraybuffer" /* 一定要加这个 不然文件内容显示不了 */,
        })
        .then((res) => {
          let a = document.createElement("a");
          let blob = new Blob([res.data]);
          let objectUrl = URL.createObjectURL(blob);
          a.setAttribute("href", objectUrl);
          a.setAttribute("download", "分类模板.xls");
          a.click();
          // console.log(objectUrl);
          URL.revokeObjectURL(objectUrl); // 释放内存
        })
        .catch((res) => {
          console.log(res);
        });
    },
    // 上传前
    handleBeforeUpload(file) {
      // 校验
      let legalName = ["xls"];
      // 拿到后缀名
      let name = file.name.substring(
        file.name.lastIndexOf(".") + 1,
        file.name.length
      );
      if (legalName.includes(name)) {
        // console.log(legalName.includes(name));
      } else {
        this.$message.info(this.$t("i18n_xls_files_only"));
        return false;
      }
    },
    handleError(err) {
      // console.log(err);
      this.$message.info(err.data);
    },
    handleSuccess(response) {},

    clearQuery() {
      this.getList();
    },
    handleSizeChange(val) {
      this.queryObj.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      console.log(val);
      this.queryObj.curPage = val;
      this.getList();
    },
    getList(type) {
      if (type === 1) {
        this.queryObj.curPage = 1;
      }
      if (type === 2) {
        // this.queryObj.curPage = 1;
      }
      this.axios
        .post(`/busFbx/getDatGoodsCategoryList`, this.queryObj)
        .then((res) => {
          if (res.data.code == 200) {
            //   console.log(res.data);
            this.tableData = res.data.data.datalList;
            this.total = res.data.data.totalCounts;
            // this.total = res.data.data.totalCounts
          } else {
            this.$message.info(res.data.message);
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    addPls,
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getList();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
};
</script>
<style scoped>
.el-table >>> th.gutter {
  display: table-cell !important;
}
</style>


// WEBPACK FOOTER //
// src/components/PersonalCenter/personalInfo/Classify.vue